import iconSquareArrowDown from '@/assets/images/icons/icon-square-arrow-down.png';
import iconSquareArrowUp from '@/assets/images/icons/icon-square-arrow-up.png';
import Accordion from '@/components/ui/Accordion/Accordion';
import type { Spec } from '@/types';
import styles from './ProductDetailAccordion.module.scss';

function ProductDetailAccordion({
  isOpen,
  setIsOpen,
  specs,
  productDetailDescription,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  specs: Spec[];
  productDetailDescription: string;
}) {
  return (
    <>
      <div className={styles.productDetail} onClick={() => setIsOpen(!isOpen)}>
        <p className={styles.productDetailTitle}>{isOpen ? 'アイテム詳細を閉じる' : 'アイテム詳細'}</p>
        <img
          src={isOpen ? iconSquareArrowUp.src : iconSquareArrowDown.src}
          alt='icon-square-arrow-down'
          className={styles.productDetailIcon}
        />
      </div>
      <Accordion isOpened={isOpen}>
        <div className={styles.content}>
          <div className={styles.specs}>
            {specs.map((spec) => (
              <div className={styles.spec} key={spec.id}>
                <span className={styles.specKey}>{spec.key}</span>
                <span className={styles.specColon}>:</span>
                <span className={styles.specValue}>{spec.value}</span>
              </div>
            ))}
          </div>
          <div className={styles.description}>{productDetailDescription}</div>
        </div>
      </Accordion>
    </>
  );
}

export default ProductDetailAccordion;
